export const stepsControlsStyle = theme => ({
  backButton: {
    marginRight: theme.spacing(2),
  },

  buttonRow: {
    marginTop: theme.spacing(2),
  },
})
